var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPointWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h17.746v17.746H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.873 2.662a6.211 6.211 0 1 1 0 12.422 6.211 6.211 0 0 1 0-12.422zM9.6 6.158H6.942v6.06h1.541V10.44h1.02c1.349 0 2.277-.844 2.277-2.137 0-1.302-.882-2.146-2.18-2.146zm-.411 1.18c.646 0 1.033.34 1.033.97 0 .634-.387.974-1.042.974h-.697V7.338z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPointWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/point-white.ef5bcc65e714ec11581121ff9551a767.svg";